import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import ErrorView from '@/views/ErrorView.vue'

Vue.use(VueRouter)

//路由表
const routes = [
  {
    path: "/",
    redirect: "/login",
    meta: {
      title: "系统登录",
      intercept: true
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      title: "系统登录",
      intercept: true
    },
  },
  {
    path: "/home",
    name: "home",
    redirect: "/home/work",
    component: () => import('@/views/HomeView.vue'),
    children: [
      {
        path: "work",
        name: "work",
        component: () => import('@/views/WorkView.vue'),
        meta: {
          title: "首页",
          intercept: false
        },
      },
      {
        path: "patient",
        name: "patient",
        component: () => import('@/views/PatientView.vue'),
        meta: {
          title: "已预约患者",
          intercept: false
        },
      },
      {
        path: "disease",
        name: "disease",
        component: () => import('@/views/DiseaseView.vue'),
        meta: {
          title: "预约业绩统计",
          intercept: false
        },
      },
      {
        path: "dabank",
        name: "dabank",
        component: () => import('@/views/DabankView.vue'),
        meta: {
          title: "资料库",
          intercept: false
        },
      },
      {
        path: "dispatch",
        name: "dispatch",
        component: () => import('@/views/DispatchView.vue'),
        meta: {
          title: "邮寄发货",
          intercept: false
        },
      },
      {
        path: "statiscs",
        name: "statiscs",
        component: () => import('@/views/StatiscsView.vue'),
        meta: {
          title: "邮寄统计",
          intercept: false
        },
      },
      {
        path: "allreport",
        name: "allreport",
        component: () => import('@/views/AllreportView.vue'),
        meta: {
          title: "总体报表",
          intercept: false
        },
      },
      {
        path: "sexreport",
        name: "sexreport",
        component: () => import('@/views/SexreportView.vue'),
        meta: {
          title: "性别",
          intercept: false
        },
      },
      {
        path: "agereport",
        name: "agereport",
        component: () => import('@/views/AgereportView.vue'),
        meta: {
          title: "年龄",
          intercept: false
        },
      },
      {
        path: "telreport",
        name: "telreport",
        component: () => import('@/views/TelreportView.vue'),
        meta: {
          title: "接待客服",
          intercept: false
        },
      },
      {
        path: "docreport",
        name: "docreport",
        component: () => import('@/views/DocreportView.vue'),
        meta: {
          title: "接待医生",
          intercept: false
        },
      },
      {
        path: "rootratio",
        name: "rootratio",
        component: () => import('@/views/RootratioView.vue'),
        meta: {
          title: "词根比率",
          intercept: false
        },
      },
      {
        path: "illness",
        name: "illness",
        component: () => import('@/views/IllnessView.vue'),
        meta: {
          title: "疾病管理",
          intercept: false
        },
      },
      {
        path: "doctor",
        name: "doctor",
        component: () => import('@/views/DoctorView.vue'),
        meta: {
          title: "医生管理",
          intercept: false
        },
      },
      {
        path: "office",
        name: "office",
        component: () => import('@/views/OfficeView.vue'),
        meta: {
          title: "科室管理",
          intercept: false
        },
      },
      {
        path: "commons",
        name: "commons",
        component: () => import('@/views/CommonsView.vue'),
        meta: {
          title: "常用功能",
          intercept: false
        },
      },
      {
        path: "channel",
        name: "channel",
        component: () => import('@/views/ChannelView.vue'),
        meta: {
          title: "资料渠道",
          intercept: false
        },
      },
      {
        path: "distribute",
        name: "distribute",
        component: () => import('@/views/DistributeView.vue'),
        meta: {
          title: "渠道派发",
          intercept: false
        },
      },
      {
        path: "personne",
        name: "personne",
        component: () => import('@/views/PersonneView.vue'),
        meta: {
          title: "人员管理",
          intercept: false
        },
      },
      {
        path: "authority",
        name: "authority",
        component: () => import('@/views/AuthorityView.vue'),
        meta: {
          title: "权限管理",
          intercept: false
        },
      },
      {
        path: "section",
        name: "section",
        component: () => import('@/views/SectionView.vue'),
        meta: {
          title: "部门管理",
          intercept: false
        },
      },
      {
        path: "logs",
        name: "logs",
        component: () => import('@/views/LogsView.vue'),
        meta: {
          title: "日志管理",
          intercept: false
        },
      },
    ]
  },
  {
    path: "/*",
    name: "404",
    component: ErrorView,
    meta: {
      title: "404页面",
      intercept: true
    },
  },
]

//路由实例
const router = new VueRouter({
  mode: "hash",
  routes: routes,
})

//路由前置守卫
router.beforeEach((to, _, next) => {
  let { intercept, title } = to.meta
  let token = localStorage.getItem("Token")
  document.title = title
  if (intercept) {
    next()
  } else {
    if (token) {
      next()
    } else {
      next("/login")
    }
  }
})

export default router
